"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const ModalNotifySetting = (props) => {
    const { visible, tagName, defaultValue, disabled = false, onClose, onToggle } = props;
    const [timelinePostEnable, setTimelinePostEnable] = (0, react_1.useState)(defaultValue[0]);
    const [articlePostEnable, setArticlePostEnable] = (0, react_1.useState)(defaultValue[1]);
    const [historyPostEnable, setHistoryPostEnable] = (0, react_1.useState)(defaultValue[2]);
    (0, react_1.useEffect)(() => {
        if (disabled) {
            setTimelinePostEnable(false);
            setArticlePostEnable(false);
            setHistoryPostEnable(false);
        }
    }, [disabled]);
    return (react_1.default.createElement(react_native_1.Modal, { visible: visible, animationType: 'fade', onRequestClose: onClose, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        } },
        react_1.default.createElement(react_native_1.View, { style: [styles.container, { width: scale_1.width, alignSelf: 'center' }] },
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, title: tagName, styleContainer: styles.header, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: "#21242D" }), onLeftPress: onClose }),
            react_1.default.createElement(react_native_1.View, { style: styles.body, pointerEvents: disabled ? 'none' : 'auto' },
                react_1.default.createElement(react_native_1.View, { style: styles.item },
                    react_1.default.createElement(react_native_1.View, { style: styles.switchView },
                        react_1.default.createElement(CustomText_1.default, { style: styles.itemTitle }, "\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u6295\u7A3F"),
                        react_1.default.createElement(components_1.SwitchSimple, { value: timelinePostEnable, onValueChange: (val) => {
                                setTimelinePostEnable(val);
                                onToggle([val, articlePostEnable, historyPostEnable]);
                            } })),
                    react_1.default.createElement(CustomText_1.default, { style: styles.itemDescription },
                        tagName,
                        "\u3055\u3093\u304C\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u306B\u6295\u7A3F\u3057\u305F\u969B\u306B\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002")),
                react_1.default.createElement(react_native_1.View, { style: styles.item },
                    react_1.default.createElement(react_native_1.View, { style: styles.switchView },
                        react_1.default.createElement(CustomText_1.default, { style: styles.itemTitle }, "\u8A18\u4E8B"),
                        react_1.default.createElement(components_1.SwitchSimple, { value: articlePostEnable, onValueChange: (val) => {
                                setArticlePostEnable(val);
                                onToggle([timelinePostEnable, val, historyPostEnable]);
                            } })),
                    react_1.default.createElement(CustomText_1.default, { style: styles.itemDescription },
                        tagName,
                        "\u3055\u3093\u304C\u8A18\u4E8B\u3092\u6295\u7A3F\u3057\u305F\u308A\u66F4\u65B0\u3057\u305F\u969B\u306B\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002")),
                react_1.default.createElement(react_native_1.View, { style: styles.item },
                    react_1.default.createElement(react_native_1.View, { style: styles.switchView },
                        react_1.default.createElement(CustomText_1.default, { style: styles.itemTitle }, "\u81EA\u5206\u53F2"),
                        react_1.default.createElement(components_1.SwitchSimple, { value: historyPostEnable, onValueChange: (val) => {
                                setHistoryPostEnable(val);
                                onToggle([timelinePostEnable, articlePostEnable, val]);
                            } })),
                    react_1.default.createElement(CustomText_1.default, { style: styles.itemDescription },
                        tagName,
                        "\u3055\u3093\u304C\u81EA\u5206\u53F2\u3092\u6295\u7A3F\u3057\u305F\u308A\u66F4\u65B0\u3057\u305F\u969B\u306B\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002"))))));
};
exports.default = ModalNotifySetting;
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
    },
    header: {
        backgroundColor: "#FEFEFE",
    },
    body: {
        flex: 1,
        paddingTop: (0, scale_1.scale)(24),
    },
    item: {
        width: '100%',
        paddingHorizontal: (0, scale_1.scale)(16),
        paddingVertical: (0, scale_1.scale)(12),
        borderBottomWidth: (0, scale_1.scale)(1),
        borderColor: '#DDDDDD'
    },
    switchView: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center'
    },
    itemTitle: {
        flex: 1,
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(22.5),
        color: '#292A33'
    },
    itemDescription: {
        width: '100%',
        paddingRight: (0, scale_1.scale)(82),
        fontSize: (0, scale_1.moderateScale)(11),
        lineHeight: (0, scale_1.moderateScale)(18.7),
        color: "#888888"
    },
});
